/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './global-property.reducer';

export const GlobalPropertyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const globalPropertyEntity = useAppSelector(state => state.globalProperty.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="globalPropertyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.globalProperty.detail.title">GlobalProperty</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.globalProperty.id">Id</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.id}</dd>
          <dt>
            <span id="property">
              <Translate contentKey="tinyMedicRestApp.globalProperty.property">Property</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.property}</dd>
          <dt>
            <span id="propertyValue">
              <Translate contentKey="tinyMedicRestApp.globalProperty.propertyValue">Property Value</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.propertyValue}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.globalProperty.description">Description</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.description}</dd>
          <dt>
            <span id="datatypeClassname">
              <Translate contentKey="tinyMedicRestApp.globalProperty.datatypeClassname">Datatype Classname</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.datatypeClassname}</dd>
          <dt>
            <span id="datatypeConfig">
              <Translate contentKey="tinyMedicRestApp.globalProperty.datatypeConfig">Datatype Config</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.datatypeConfig}</dd>
          <dt>
            <span id="preferredHandlerClassname">
              <Translate contentKey="tinyMedicRestApp.globalProperty.preferredHandlerClassname">Preferred Handler Classname</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.preferredHandlerClassname}</dd>
          <dt>
            <span id="handlerConfig">
              <Translate contentKey="tinyMedicRestApp.globalProperty.handlerConfig">Handler Config</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.handlerConfig}</dd>
          <dt>
            <span id="dirty">
              <Translate contentKey="tinyMedicRestApp.globalProperty.dirty">Dirty</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.dirty ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.globalProperty.active">Active</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.globalProperty.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.globalProperty.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.globalProperty.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.globalProperty.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{globalPropertyEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/global-property" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/global-property/${globalPropertyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GlobalPropertyDetail;
